import { jsx as _jsx } from "react/jsx-runtime";
import { BLOCK_BACKGROUND_COLORS, resolveBlockBackgroundPalette, BLOCK_SPACING_PX, BLOCK_MOBILE_SPACING_PX, resolveBlockSpacing, } from "@diality/contracts";
import { cn } from "../lib/utils";
/** Owns outer block spacing for both the CMS canvas and the public frontend. */
export function BlockWrapper({ backgroundPalette, paddingTop, paddingBottom, className, style, children, ...rest }) {
    const background = BLOCK_BACKGROUND_COLORS[resolveBlockBackgroundPalette(backgroundPalette)];
    const top = resolveBlockSpacing(paddingTop);
    const bottom = resolveBlockSpacing(paddingBottom);
    return (_jsx("div", { ...rest, className: cn("@container w-full", className), style: {
            ...style,
            backgroundColor: background,
            "--block-background": background,
        }, children: _jsx("div", { className: "pt-[var(--block-top-mobile)] pb-[var(--block-bottom-mobile)] @min-[901px]:pt-[var(--block-top)] @min-[901px]:pb-[var(--block-bottom)]", style: {
                "--block-top": `${BLOCK_SPACING_PX[top]}px`,
                "--block-bottom": `${BLOCK_SPACING_PX[bottom]}px`,
                "--block-top-mobile": `${BLOCK_MOBILE_SPACING_PX[top]}px`,
                "--block-bottom-mobile": `${BLOCK_MOBILE_SPACING_PX[bottom]}px`,
            }, children: children }) }));
}
//# sourceMappingURL=block-wrapper.js.map